// console.log('Header drawer contents goes here');



class HeaderDrawer extends HTMLElement {
    constructor() {
        super();

        this.scrollPosition = 0;
        this.HeaderDrawer = this;
        this.HeaderDrawerToggle = this.querySelector('.header-drawer-toggle');
        this.HeaderDrawerDetails = this.querySelector('.header-drawer-details');
        this.subMenuItemIcons = this.querySelectorAll('.header-drawer-main-menu-item-icon');
        this.subMenuItemToggles = this.querySelectorAll('.header-drawer-main-menu-subitems-panel__title');
        // this.subMenuItemIcons = this.querySelectorAll('.header-drawer-main-menu-item-icon');
        // this.HeaderDrawerClose = this.querySelector('.cart-drawer-close');
        // this.HeaderDrawerOverlay = this.querySelector('.cart-drawer-overlay');

        this.HeaderDrawerToggle.addEventListener('click', (event) => this.onClick(event))

        // this.HeaderDrawerClose.addEventListener('click', () => this.close())
        // this.HeaderDrawerOverlay.addEventListener('click', () => this.close())


        document.addEventListener('click', (event) => {
            const headerDrawer = this.HeaderDrawer;
            if (
                this.classList.contains('active') &&
                event.target !== headerDrawer &&
                !headerDrawer.contains(event.target)
            ) {
                this.close()
            }
        })


        for (let subMenuItemIcon of this.subMenuItemIcons) {
            subMenuItemIcon.addEventListener('click', () => this.subMenuClick(subMenuItemIcon))
        }

        for (let subMenuItemToggle of this.subMenuItemToggles) {
            subMenuItemToggle.addEventListener('click', () => this.subMenuToggleClick(subMenuItemToggle))
        }
    }

    onClick(event) {
        event.preventDefault();

        if (this.classList.contains('active')) {
            this.close();
        }
        else {
            this.open()
        }
    }

    open() {
        this.lockPageScroll();

        // On récupère la section parente et on mesure sa hauteur exacte
        const headerSection = this.closest('.shopify-header-section');
        if (headerSection) {
            document.documentElement.style.setProperty(
                '--theme-header-drawer-offset',
                `${headerSection.offsetHeight}px`
            );
        }

        this.HeaderDrawerDetails.classList.add('visible');

        setTimeout(() => {
            this.HeaderDrawer.classList.add('active')
        }, 50);
    }
    close() {
        if (!this.HeaderDrawer.classList.contains('active')) return;

        this.HeaderDrawer.classList.remove('active')

        setTimeout(() => {
            // this.HeaderDrawerDetails.style.display = 'none';
            this.HeaderDrawerDetails.classList.remove('visible');
            this.unlockPageScroll();
        }, 300);
    }

    subMenuClick(subMenuItemIcon) {

        const subMenuItem = subMenuItemIcon.parentNode.parentNode;

        this.HeaderDrawerDetails.classList.add('inactive');
        subMenuItem.classList.contains('active') ? subMenuItem.classList.remove('active') : subMenuItem.classList.add('active')
    }

    subMenuToggleClick(subMenuItemIcon) {

        const subMenuItem = subMenuItemIcon.parentNode.parentNode;

        this.HeaderDrawerDetails.classList.remove('inactive');
        subMenuItem.classList.remove('active')
    }

    lockPageScroll() {
        this.scrollPosition = window.scrollY || window.pageYOffset || 0;
        const headerSection = this.closest('.shopify-header-section');

        // 1. On mémorise la position exacte du header à l'écran avant toute modification
        let initialTop = 0;
        if (headerSection) {
            initialTop = headerSection.getBoundingClientRect().top;
        }

        document.documentElement.classList.add('overflow-hidden', 'header-drawer-open');
        document.body.classList.add('overflow-hidden', 'header-drawer-open');

        // On fige le body à sa position de scroll exacte
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.width = '100%';

        // 2. On calcule où le navigateur a physiquement déplacé le header...
        if (headerSection) {
            const newTop = headerSection.getBoundingClientRect().top;
            const offset = initialTop - newTop; // ... et on calcule la différence exacte

            // On désactive les animations CSS pour éviter un effet de "glissement"
            headerSection.style.transition = 'none';
            // On translate le header pour qu'il reste figé pile où il était
            headerSection.style.transform = `translateY(${offset}px)`;
        }
    }

    unlockPageScroll() {
        document.documentElement.classList.remove('overflow-hidden', 'header-drawer-open');
        document.body.classList.remove('overflow-hidden', 'header-drawer-open');

        // On libère le body
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';

        // On nettoie la translation du header
        const headerSection = this.closest('.shopify-header-section');
        if (headerSection) {
            headerSection.style.transform = '';

            // Un micro-délai avant de remettre les transitions pour éviter un flash visuel
            setTimeout(() => {
                headerSection.style.transition = '';
            }, 50);
        }

        // On restaure instantanément la position de l'utilisateur
        window.scrollTo(0, this.scrollPosition);
    }

}

customElements.define('header-drawer', HeaderDrawer);
